export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 1,
    "title": "What is the primary goal of AI governance?",
    "description": "To ensure that AI systems are designed, deployed, and used in a way that aligns with legal, ethical, organizational values, and risk management objectives."
  },
  {
    "id": 2,
    "topic_id": 1,
    "title": "AI governance includes mechanisms for ___, ___, and ___ AI systems.",
    "description": "designing, deploying, monitoring"
  },
  {
    "id": 3,
    "topic_id": 1,
    "title": "True/False: AI governance applies only during the initial deployment phase of an AI system.",
    "description": "False. Governance applies throughout the entire AI lifecycle."
  },
  {
    "id": 4,
    "topic_id": 1,
    "title": "What is a key reason that organizations implement AI governance frameworks?",
    "description": "To proactively identify and mitigate risks associated with AI, such as bias, lack of transparency, or unintended outcomes, and to ensure compliance, accountability, and trustworthiness."
  },
  {
    "id": 5,
    "topic_id": 1,
    "title": "What is the significance of stakeholder mapping in AI governance?",
    "description": "It helps identify who is affected by an AI system and ensures that their needs and concerns are addressed throughout the system’s lifecycle."
  },
  {
    "id": 6,
    "topic_id": 1,
    "title": "___ risk refers to harm that arises when AI systems behave in ways that diverge from intended goals or values.",
    "description": "Misalignment"
  },
  {
    "id": 7,
    "topic_id": 4,
    "title": "True/False: Operational risks in AI are limited to security breaches and data loss.",
    "description": "False. They also include drift, model failure, and human-machine miscoordination."
  },
  {
    "id": 8,
    "topic_id": 4,
    "title": "What does the term “automation bias” refer to in AI systems?",
    "description": "The human tendency to over-rely on AI system outputs, even when they may be incorrect."
  },
  {
    "id": 9,
    "topic_id": 4,
    "title": "Why is feedback loop analysis important in AI governance?",
    "description": "It helps anticipate how an AI system may reinforce or amplify outcomes over time, including unintended social consequences."
  },
  {
    "id": 10,
    "topic_id": 1,
    "title": "A risk register is used to document ___, their likelihood, severity, and mitigation plans.",
    "description": "identified risks"
  },
  {
    "id": 11,
    "topic_id": 4,
    "title": "True/False: Risk treatment plans should be static and finalized before deployment.",
    "description": "False. They should be dynamic and adaptable throughout the AI lifecycle."
  },
  {
    "id": 12,
    "topic_id": 1,
    "title": "What is the role of a “risk owner” in an AI project?",
    "description": "A designated person responsible for monitoring, responding to, and reporting on a specific risk."
  },
  {
    "id": 13,
    "topic_id": 3,
    "title": "The effectiveness of a risk control measure should be regularly ___ and ___.",
    "description": "evaluated, updated"
  },
  {
    "id": 14,
    "topic_id": 1,
    "title": "What differentiates inherent risk from residual risk?",
    "description": "Inherent risk is the level of risk before any controls are applied; residual risk is what remains after controls are implemented."
  },
  {
    "id": 15,
    "topic_id": 4,
    "title": "What makes AI risk forecasting more complex than traditional IT systems?",
    "description": "The non-deterministic behavior of many AI systems and the potential for emergent, unpredictable interactions with users or dynamic environments."
  },
  {
    "id": 16,
    "topic_id": 1,
    "title": "True/False: AI development teams are solely responsible for governance compliance.",
    "description": "False. Governance responsibilities are shared across legal, compliance, IT, and business units."
  },
  {
    "id": 17,
    "topic_id": 4,
    "title": "Human-on-the-loop systems are designed so that a human can ___ system decisions during or after they are finalized.",
    "description": "override or intervene in"
  },
  {
    "id": 18,
    "topic_id": 1,
    "title": "Why is it important to document the AI system’s intended use?",
    "description": "It sets expectations for performance, guides risk analysis, supports accountability if systems are repurposed, and aids in troubleshooting issues."
  },
  {
    "id": 19,
    "topic_id": 3,
    "title": "What is a potential risk of using synthetic data during AI model training?",
    "description": "If poorly generated, it may introduce unrealistic patterns or fail to capture important edge cases, leading to poor generalization."
  },
  {
    "id": 20,
    "topic_id": 3,
    "title": "___ is the preparation of raw data into a clean, structured format suitable for training, including normalization, transformation, and sometimes anonymization.",
    "description": "Data preprocessing"
  },
  {
    "id": 21,
    "topic_id": 2,
    "title": "True/False: Training an AI system on third-party data without a license can pose legal risks.",
    "description": "True."
  },
  {
    "id": 22,
    "topic_id": 3,
    "title": "What is the purpose of stratified sampling in AI data preparation?",
    "description": "To ensure that the training, validation, and test sets maintain the same distribution of key variables, improving model reliability."
  },
  {
    "id": 23,
    "topic_id": 3,
    "title": "The ___ set is used to measure model performance on previously unseen data.",
    "description": "test"
  },
  {
    "id": 24,
    "topic_id": 3,
    "title": "What does model regularization help prevent?",
    "description": "Overfitting to training data by penalizing overly complex models."
  },
  {
    "id": 25,
    "topic_id": 3,
    "title": "True/False: Validation loss that increases while training loss decreases may indicate overfitting.",
    "description": "True."
  },
  {
    "id": 26,
    "topic_id": 4,
    "title": "What is a confusion matrix used for in AI evaluation?",
    "description": "To evaluate classification performance by showing true positives, false positives, true negatives, and false negatives."
  },
  {
    "id": 27,
    "topic_id": 3,
    "title": "Precision is the ratio of true positives to ___.",
    "description": "true positives + false positives"
  },
  {
    "id": 28,
    "topic_id": 3,
    "title": "What are vanishing gradients, and why are they problematic in training?",
    "description": "They occur when gradients become too small to update weights effectively, especially in deep neural networks, hindering learning."
  },
  {
    "id": 29,
    "topic_id": 4,
    "title": "True/False: Accuracy is always a sufficient metric for evaluating AI models.",
    "description": "False. It may be misleading in imbalanced datasets."
  },
  {
    "id": 30,
    "topic_id": 3,
    "title": "Why might an organization choose to use SHAP values or LIME in their AI pipeline?",
    "description": "To improve the explainability of model predictions and support transparency and accountability in high-risk use-cases."
  },
  {
    "id": 31,
    "topic_id": 4,
    "title": "___ testing exposes an AI model to previously unseen, realistic data to simulate deployment performance.",
    "description": "Shadow mode"
  },
  {
    "id": 32,
    "topic_id": 3,
    "title": "What distinguishes a model card from a model registry?",
    "description": "A model card documents the purpose, performance, and limitations of a specific model, while a model registry tracks multiple models and their versions."
  },
  {
    "id": 33,
    "topic_id": 3,
    "title": "True/False: It is acceptable to use a test set multiple times during training, as long as it’s not the training set.",
    "description": "False. Reusing the test set introduces data leakage, inflates performance metrics, and prevents accurate evaluation of model generalization."
  },
  {
    "id": 34,
    "topic_id": 3,
    "title": "What is the primary goal of validation during the training phase?",
    "description": "To fine-tune model parameters and assess generalizability without touching the test set."
  },
  {
    "id": 35,
    "topic_id": 1,
    "title": "A well-documented AI lifecycle includes stages such as ___, ___, training, testing, deployment, and monitoring.",
    "description": "design, data acquisition"
  },
  {
    "id": 36,
    "topic_id": 3,
    "title": "What is the risk of concept drift?",
    "description": "It occurs when the statistical properties between input features and the target variable change over time, degrading model performance."
  },
  {
    "id": 37,
    "topic_id": 4,
    "title": "True/False: A model’s performance on validation data guarantees success in real-world deployment.",
    "description": "False. Real-world data can differ significantly from validation data."
  },
  {
    "id": 38,
    "topic_id": 2,
    "title": "What are the OECD AI Principles designed to promote?",
    "description": "Responsible stewardship of trustworthy AI that respects human rights, democratic values, and the rule of law."
  },
  {
    "id": 39,
    "topic_id": 2,
    "title": "True/False: The OECD AI Principles only apply to government agencies, not private organizations.",
    "description": "False. They are meant to guide both public- and private-sector AI development."
  },
  {
    "id": 40,
    "topic_id": 2,
    "title": "The OECD principle of robustness emphasizes that AI systems should be ___ and ___ throughout their lifecycle.",
    "description": "resilient, secure"
  },
  {
    "id": 41,
    "topic_id": 3,
    "title": "How does the OECD principle of transparency influence system design?",
    "description": "It encourages the inclusion of interpretable outputs and documentation that explains decision-making logic to affected individuals."
  },
  {
    "id": 42,
    "topic_id": 2,
    "title": "What does the NIST AI Risk Management Framework (AI RMF) aim to do?",
    "description": "Help organizations manage risks associated with AI systems in a flexible, voluntary, and rights-preserving way."
  },
  {
    "id": 43,
    "topic_id": 2,
    "title": "The NIST AI RMF core functions are ___, ___, ___, and ___.",
    "description": "Map, Measure, Manage, Govern"
  },
  {
    "id": 44,
    "topic_id": 1,
    "title": "What is the purpose of the “Map” function in the NIST AI RMF?",
    "description": "To establish the context, risks, and use-cases of the AI system, forming the foundation of governance."
  },
  {
    "id": 45,
    "topic_id": 2,
    "title": "True/False: The NIST AI RMF is a mandatory compliance document for all U.S. businesses.",
    "description": "False. It is voluntary and intended to guide best practices."
  },
  {
    "id": 46,
    "topic_id": 2,
    "title": "What distinguishes the ARIA framework from the broader NIST AI RMF?",
    "description": "NIST ARIA is an initiative exploring methods for AI assurance, including testing and evaluation approaches, while NIST AI RMF is a framework consisting of standards, guidelines, and best practices for managing AI-related risk."
  },
  {
    "id": 47,
    "topic_id": 1,
    "title": "Why might organizations struggle to implement the “Govern” function in the NIST AI RMF?",
    "description": "Because it requires sustained cross-functional oversight, leadership buy-in, and organizational change."
  },
  {
    "id": 48,
    "topic_id": 2,
    "title": "ISO/IEC 42001 is the world’s first AI-specific ___ standard.",
    "description": "management system"
  },
  {
    "id": 49,
    "topic_id": 1,
    "title": "What does ISO/IEC 42001 require of organizations regarding AI policy?",
    "description": "That they define and document a clear AI policy aligned with the organization’s goals, stakeholder expectations, risk appetite, and regulatory obligations."
  },
  {
    "id": 50,
    "topic_id": 2,
    "title": "True/False: ISO/IEC 42001 certification requires an audit by an accredited third-party auditor.",
    "description": "True."
  },
  {
    "id": 51,
    "topic_id": 2,
    "title": "What is the function of model documentation in ISO/IEC 42001?",
    "description": "To promote traceability, accountability, and reproducibility across the AI system lifecycle."
  },
  {
    "id": 52,
    "topic_id": 1,
    "title": "A management system for AI should include roles, responsibilities, and ___ processes to assess and control AI risks.",
    "description": "governance"
  },
  {
    "id": 53,
    "topic_id": 1,
    "title": "What is the purpose of lifecycle documentation in AI system design?",
    "description": "To provide a transparent and auditable record of decisions, assumptions, and changes throughout the system’s development and use."
  },
  {
    "id": 54,
    "topic_id": 3,
    "title": "Documenting ___ decisions helps ensure future reviewers understand tradeoffs made during design.",
    "description": "architectural or design"
  },
  {
    "id": 55,
    "topic_id": 1,
    "title": "True/False: Design documentation should be updated only at the beginning of the project.",
    "description": "False. It should be continuously maintained throughout the AI lifecycle."
  },
  {
    "id": 56,
    "topic_id": 3,
    "title": "Why is it important to record model hyperparameters and versioning?",
    "description": "It enables reproducibility and facilitates troubleshooting, model comparison, and auditing."
  },
  {
    "id": 57,
    "topic_id": 3,
    "title": "What is the significance of tracking third-party components in AI systems?",
    "description": "It helps ensure compliance with licensing, manage security vulnerabilities, and identify risks."
  },
  {
    "id": 58,
    "topic_id": 3,
    "title": "A ___ log can provide timestamped records of key actions, decisions, and results during system development.",
    "description": "change or change control"
  },
  {
    "id": 59,
    "topic_id": 3,
    "title": "What is the role of system performance benchmarks in design documentation?",
    "description": "To set expectations for real-world operation and guide decisions about model improvements, retraining, or replacement."
  },
  {
    "id": 60,
    "topic_id": 3,
    "title": "True/False: Documentation of fairness assessments is not required unless legally mandated.",
    "description": "False. It is increasingly seen as essential to responsible AI practice."
  },
  {
    "id": 61,
    "topic_id": 3,
    "title": "What are some methods used for model explainability?",
    "description": "Methods such as SHAP, LIME, decision trees, and saliency maps are used for model explainability."
  },
  {
    "id": 62,
    "topic_id": 4,
    "title": "Explainability techniques are most important when AI systems are used in ___-impact domains.",
    "description": "high"
  },
  {
    "id": 63,
    "topic_id": 4,
    "title": "What is shadow mode testing, and when is it used?",
    "description": "A method where an AI system is run in parallel to real operations without affecting decisions, to assess performance before deployment."
  },
  {
    "id": 64,
    "topic_id": 4,
    "title": "True/False: Shadow mode testing can identify distribution shifts in real-time data before live deployment.",
    "description": "True."
  },
  {
    "id": 65,
    "topic_id": 4,
    "title": "Acceptance testing validates whether an AI system meets ___, ___, ___, and ___ requirements.",
    "description": "functional, non-functional, regulatory, security, privacy"
  },
  {
    "id": 66,
    "topic_id": 4,
    "title": "What is the purpose of red-team testing in AI assurance?",
    "description": "To simulate adversarial attacks or misuse scenarios to identify vulnerabilities in the AI system."
  },
  {
    "id": 67,
    "topic_id": 4,
    "title": "What distinguishes internal audits from external audits of AI systems?",
    "description": "Internal audits are conducted by in-house teams; external audits involve third parties and may be used for certification, compliance, or objectivity purposes."
  },
  {
    "id": 68,
    "topic_id": 3,
    "title": "True/False: AI testing must be completed before deployment and not after.",
    "description": "False. Post-deployment testing and monitoring are essential parts of assurance."
  },
  {
    "id": 69,
    "topic_id": 3,
    "title": "Bias detection in AI often involves evaluating both ___ and ___ fairness.",
    "description": "statistical, individual"
  },
  {
    "id": 70,
    "topic_id": 4,
    "title": "What is meant by robustness testing in the context of AI assurance?",
    "description": "Evaluating how well an AI system performs under stress, edge cases, or adversarial conditions."
  },
  {
    "id": 71,
    "topic_id": 4,
    "title": "What does conformance testing seek to establish in an AI system?",
    "description": "That the system meets defined technical specifications, standards, or legal requirements."
  },
  {
    "id": 72,
    "topic_id": 3,
    "title": "Non-functional testing focuses on characteristics like ___, ___, ___, ___, and usability.",
    "description": "performance, reliability, security, privacy"
  },
  {
    "id": 73,
    "topic_id": 4,
    "title": "What is the goal of incident response in the context of AI systems?",
    "description": "To identify, contain, remediate, and report issues such as system failures, data breaches, or ethical harms."
  },
  {
    "id": 74,
    "topic_id": 3,
    "title": "AI incidents should be logged with time, impact, root cause, and ___ actions.",
    "description": "corrective"
  },
  {
    "id": 75,
    "topic_id": 2,
    "title": "True/False: All AI incidents should be reported to external regulators regardless of impact.",
    "description": "False. Only certain incidents must be reported externally, depending on applicable laws, industry regulations, and the severity or type of impact."
  },
  {
    "id": 76,
    "topic_id": 3,
    "title": "What role does root cause analysis play in AI incident management?",
    "description": "It helps organizations identify underlying issues and prevent recurrence by improving systems, processes, or controls."
  },
  {
    "id": 77,
    "topic_id": 4,
    "title": "What is a challenge of disclosing AI incidents publicly?",
    "description": "Balancing transparency and accountability with legal risk, reputational harm, and protection of proprietary and personal information."
  },
  {
    "id": 78,
    "topic_id": 1,
    "title": "AI vendors must often agree to contractual terms that limit liability and allocate ___ responsibilities.",
    "description": "governance"
  },
  {
    "id": 79,
    "topic_id": 2,
    "title": "True/False: Open-source AI tools carry no legal risk since they are publicly available.",
    "description": "False. Their use may still pose compliance, licensing, and accountability risks."
  },
  {
    "id": 80,
    "topic_id": 4,
    "title": "What does the term “downstream harm” refer to in AI governance?",
    "description": "Negative consequences experienced by individuals or groups not directly involved in developing, deploying, or using the AI system."
  },
  {
    "id": 81,
    "topic_id": 4,
    "title": "Why should organizations forecast secondary uses of AI systems?",
    "description": "To anticipate and mitigate risks of misuse, repurposing, or value misalignment across contexts."
  },
  {
    "id": 82,
    "topic_id": 1,
    "title": "AI vendor contracts should address data ownership, audit rights, ___, ___, and ___ obligations.",
    "description": "confidentiality, liability, or security"
  },
  {
    "id": 83,
    "topic_id": 2,
    "title": "What are the benefits of shared AI assurance models (for example, third-party audits)?",
    "description": "They increase trust and standardization while reducing the burden on individual organizations."
  },
  {
    "id": 84,
    "topic_id": 2,
    "title": "True/False: All AI failures must be documented and disclosed publicly to meet AI governance obligations.",
    "description": "False. Disclosure depends on regulatory and contractual requirements."
  },
  {
    "id": 85,
    "topic_id": 4,
    "title": "___ assessments evaluate the risks and effects of AI systems before they are deployed.",
    "description": "Impact"
  },
  {
    "id": 86,
    "topic_id": 3,
    "title": "What is the benefit of continuous risk monitoring for AI systems?",
    "description": "It enables timely detection of emerging issues such as drift, bias, and performance degradation."
  },
  {
    "id": 87,
    "topic_id": 4,
    "title": "What kind of system might benefit most from scenario-based red teaming?",
    "description": "AI systems operating in adversarial or unpredictable environments (for example, finance, defense, elections)."
  },
  {
    "id": 88,
    "topic_id": 3,
    "title": "True/False: It is sufficient to document training data but not validation or test data.",
    "description": "False. All training, validation, and test datasets should be documented to ensure reproducibility and traceability."
  },
  {
    "id": 89,
    "topic_id": 1,
    "title": "What is the difference between a governance policy and a governance control?",
    "description": "A policy defines high-level principles and goals, while a control implements specific actions to enforce them."
  },
  {
    "id": 90,
    "topic_id": 1,
    "title": "Governance frameworks must remain ___ to adapt to new technologies, risks, and regulations.",
    "description": "agile or flexible"
  },
  {
    "id": 91,
    "topic_id": 3,
    "title": "What is a “model operations” (ModelOps) function?",
    "description": "A discipline that focuses on deploying, monitoring, and governing AI models in production."
  },
  {
    "id": 92,
    "topic_id": 1,
    "title": "True/False: AI governance only applies to technical staff.",
    "description": "False. It involves legal, compliance, operations, leadership, and other roles."
  },
  {
    "id": 93,
    "topic_id": 1,
    "title": "What does “embedding governance” into lifecycle processes mean?",
    "description": "Integrating oversight, documentation, and compliance checks into existing workflows and tools."
  },
  {
    "id": 94,
    "topic_id": 1,
    "title": "A well-functioning AI governance program includes clearly defined ___ of responsibility.",
    "description": "lines"
  },
  {
    "id": 95,
    "topic_id": 1,
    "title": "What makes governance for generative AI systems particularly challenging?",
    "description": "Their outputs can be non-deterministic, hard to attribute, and potentially misused or hallucinated."
  },
  {
    "id": 96,
    "topic_id": 1,
    "title": "True/False: Generative AI requires more documentation and oversight than predictive models.",
    "description": "True. Due to risks related to hallucination, bias, copyright, and misuse."
  },
  {
    "id": 97,
    "topic_id": 1,
    "title": "Why should AI governance programs be reviewed periodically?",
    "description": "To ensure they remain aligned with evolving technologies, regulatory changes, and stakeholder expectations."
  },
  {
    "id": 98,
    "topic_id": 1,
    "title": "Effective governance programs must balance control with ___ to support innovation.",
    "description": "flexibility"
  },
  {
    "id": 99,
    "topic_id": 4,
    "title": "What is the purpose of a “fit-for-purpose” assessment in AI deployment?",
    "description": "To ensure the AI system is appropriate for its intended use and context before going live."
  },
  {
    "id": 100,
    "topic_id": 1,
    "title": "What is the benefit of documenting exceptions or deviations from policy?",
    "description": "It provides a clear rationale and audit trail and supports transparency in governance decision-making."
  },
  {
    "id": 101,
    "topic_id": 1,
    "title": "Organizations may tailor AI governance frameworks to reflect industry norms, local laws, and ___.",
    "description": "organizational culture"
  },
  {
    "id": 102,
    "topic_id": 1,
    "title": "True/False: There is a universal AI governance framework accepted across all industries and countries.",
    "description": "False. Governance frameworks must be adapted to context and jurisdiction."
  },
  {
    "id": 103,
    "topic_id": 1,
    "title": "Why is role clarity important in AI governance?",
    "description": "It ensures accountability for decisions, tasks, and compliance, reducing the risk of oversight gaps or overlaps."
  },
  {
    "id": 104,
    "topic_id": 4,
    "title": "AI assurance mechanisms must be proportionate to the ___ of the system.",
    "description": "risk level"
  },
  {
    "id": 105,
    "topic_id": 200,
    "title": "Be able to explain the various types of AI systems.",
    "description": "AI systems are classified and categorized in various ways, based on their capabilities, functions, and how they are trained and used. The types of AI systems include weak/narrow AI, general AI, and artificial superintelligence (not all exist today). AI functions include reactive machines, limited-memory AI, theory of mind AI, and robotics."
  },
  {
    "id": 106,
    "topic_id": 200,
    "title": "Know the characteristics of AI that necessitate governance.",
    "description": "While AI systems can improve organizational efficiencies and quality, they are so potentially powerful that the consequences of unintended outcomes can destroy an organization. These characteristics include complexity, opacity, autonomy, speed and scale, and potential misuse and harm."
  },
  {
    "id": 107,
    "topic_id": 200,
    "title": "Know the principles of responsible AI.",
    "description": "While AI systems can improve organizational efficiencies and quality, they are so potentially powerful that the consequences of unintended outcomes can harm citizens, groups, organizations, and society as a whole. Thus, AI systems must be responsibly developed. The principles of responsible AI include ethics, fairness, privacy, security, transparency, explainability, and accountability."
  },
  {
    "id": 108,
    "topic_id": 200,
    "title": "Be able to define the roles of AI developers, deployers, and users.",
    "description": "AI governance assigns different responsibilities based on how individuals interact with AI systems. Developers design and train models and are responsible for documentation, fairness testing, and technical transparency. Deployers integrate models into operational environments, manage infrastructure, and monitor performance. Users apply AI outputs in real-world contexts and are often the first to notice failures, bias, or unintended consequences. Understanding the distinctions among these roles is critical for ensuring appropriate safeguards are in place at every phase of the AI lifecycle."
  },
  {
    "id": 109,
    "topic_id": 200,
    "title": "Know why cross-functional collaboration is critical in AI governance.",
    "description": "AI governance requires input from various functions, including legal, technical, ethical, operational, and business. Each stakeholder group identifies different risks and can detect failures that others may overlook. Cross-functional collaboration ensures that ethical issues, regulatory compliance, risk, and business value are considered together, not in silos. This collaboration often takes the form of governance committees, risk and compliance reviews, and multi-role project teams. You need to recognize when and how diverse roles should coordinate to govern responsibly."
  },
  {
    "id": 110,
    "topic_id": 200,
    "title": "Understand how governance strategies vary based on company size, risk tolerance, and other factors.",
    "description": "Smaller or early-stage companies often rely on lightweight governance such as checklists, part-time ethics advisors, or external audits. Larger organizations—with more models in production, regulatory exposure, and public visibility—require formalized governance structures, dedicated risk teams, and ongoing compliance reporting. Additionally, a company’s risk tolerance (for example, conservative vs. experimental) influences how strict or flexible governance controls should be. Be prepared to evaluate how governance approaches scale according to organizational context."
  },
  {
    "id": 111,
    "topic_id": 200,
    "title": "Be prepared to identify role-specific responsibilities across the AI lifecycle.",
    "description": "Governance must be aligned with the various phases of an AI system’s lifecycle, encompassing development, deployment, and monitoring. Developers are accountable for data integrity, model documentation, and fairness testing. Deployers are responsible for post-deployment observability, rollback plans, and integration controls. Users must be trained to detect problems and understand when to escalate concerns. The exam may present lifecycle scenarios and ask you to identify who is responsible at key checkpoints."
  },
  {
    "id": 112,
    "topic_id": 200,
    "title": "Recognize the components of an effective AI governance training program.",
    "description": "AI governance training should be tailored to the responsibilities and literacy level of each stakeholder group. Executives need strategic alignment and risk awareness; developers require tools for bias testing and transparency; users must understand how to interpret or challenge AI outcomes. Strong programs combine live training, e-learning, policy walkthroughs, and case-based exercises. Expect questions that test your understanding of how to build scalable, role-appropriate awareness initiatives."
  },
  {
    "id": 113,
    "topic_id": 200,
    "title": "Be able to explain how AI governance policies must span the entire AI lifecycle, from use case selection to incident response.",
    "description": "Governance isn’t a one-time activity. The exam will test your understanding that oversight must be embedded at every stage—beginning with ethical use case vetting, through data sourcing, model design, deployment, and ongoing monitoring. Each phase has unique risks and requires distinct policy attention."
  },
  {
    "id": 114,
    "topic_id": 200,
    "title": "Understand how privacy and security policies must address model-specific risks, such as inference attacks and data memorization.",
    "description": "Unlike traditional systems, AI models can unintentionally leak personal data or be probed to reveal training records. You’ll need to recognize where traditional controls fall short and how concepts like differential privacy, membership inference testing, and lifecycle data retention apply in AI contexts."
  },
  {
    "id": 115,
    "topic_id": 200,
    "title": "Be aware of procurement and third-party management practices that must include AI-specific reviews, documentation, and risk controls.",
    "description": "Exam scenarios may involve vendors providing AI-enabled services. You’ll be expected to identify appropriate due diligence steps, such as requesting model transparency, understanding the origins of training data, and incorporating AI-specific contractual clauses regarding fairness and explainability."
  },
  {
    "id": 116,
    "topic_id": 200,
    "title": "Understand traditional data governance principles, such as purpose limitation and data minimization, that must be reinterpreted in the context of AI.",
    "description": "AI challenges static notions of data use. The test may assess your ability to reason about issues such as model reuse, synthetic data, or reidentification risks. Understanding how foundational privacy concepts evolve in the age of machine learning is key."
  },
  {
    "id": 117,
    "topic_id": 200,
    "title": "Be able to explain how contractual language with AI vendors must cover bias, explainability, data usage, and auditability.",
    "description": "Many third-party risks can only be mitigated through strong contract terms. You may face questions about what should be included in service agreements or how to structure accountability when using external AI models or services."
  },
  {
    "id": 118,
    "topic_id": 200,
    "title": "Processing of sensitive data is prohibited by default under GDPR unless a specific legal exception applies, such as explicit consent or substantial public interest.",
    "description": "Special category data — including biometrics, health, religion, and political beliefs — cannot be processed unless one of a narrow set of exceptions under GDPR Article 9(2) applies. Explicit consent must be freely given, specific, informed, and documented. Where obtaining consent is not feasible, controllers must justify their processing under another recognized legal basis and apply additional safeguards."
  },
  {
    "id": 119,
    "topic_id": 200,
    "title": "Data controllers are accountable for the entire AI lifecycle, including DPIAs, lawful basis, data subject rights, vendor oversight, and compliance with cross-border transfer regulations.",
    "description": "Controllers must not only ensure compliance but demonstrate it, including conducting DPIAs for high-risk AI systems, maintaining lawful processing grounds, fulfilling rights requests, managing processor relationships under GDPR Article 28, and using mechanisms like SCCs or TIAs for international transfers. These responsibilities cannot be delegated or ignored in AI contexts."
  },
  {
    "id": 120,
    "topic_id": 200,
    "title": "Purpose limitation, data minimization, and privacy by design are foundational to trustworthy AI governance and must be embedded from the outset.",
    "description": "AI systems frequently challenge these principles due to their dynamic nature and appetite for data. Still, data should only be collected for defined, lawful purposes and minimized to what is necessary. Privacy by design requires integrating privacy controls throughout development, not as an afterthought, including feature selection, model explainability, and user opt-outs."
  },
  {
    "id": 121,
    "topic_id": 200,
    "title": "AI systems can infer sensitive attributes (for example, race, religion, health) even without explicit collection, which still triggers legal obligations.",
    "description": "Inferred sensitive data is subject to the same protections as explicitly collected data. Controllers must assess whether their systems are generating protected characteristics (intentionally or not) and apply appropriate legal bases and safeguards. Failing to do so risks unlawful profiling, discrimination, and regulatory action."
  },
  {
    "id": 122,
    "topic_id": 200,
    "title": "Automated decisions involving special category data may be restricted or require meaningful human involvement and additional safeguards.",
    "description": "Under GDPR Article 22, individuals have the right not to be subject to decisions based solely on automated processing that produce legal or similarly significant effects. If such processing involves special category data, it is even more tightly restricted. Where permitted, these systems must provide explainability, human review, and redress mechanisms for affected individuals."
  },
  {
    "id": 123,
    "topic_id": 200,
    "title": "Appreciate that regulations and standards have not caught up to AI’s new paradigms.",
    "description": "With history as a guide, AI capabilities are creating challenges with existing regulations and case law. Organizations should err on the side of caution and conduct rigorous diligence when implementing new AI systems."
  },
  {
    "id": 124,
    "topic_id": 200,
    "title": "Understand how intellectual property laws affect AI training and outputs.",
    "description": "AI systems trained on copyrighted content may infringe on intellectual property rights, particularly if they reproduce or closely mimic protected works. Organizations must assess whether copyrighted training data use qualifies as fair use, secure appropriate licenses, and document data provenance to mitigate IP risk."
  },
  {
    "id": 125,
    "topic_id": 200,
    "title": "Recognize how non-discrimination laws apply to AI in regulated sectors.",
    "description": "Laws like Title VII, ECOA, and FHA prohibit intentional and unintentional discrimination and practices that disproportionately impact protected groups. AI systems used in hiring, credit, housing, and insurance must be audited for disparate impact and must not rely on proxy variables tied to race, gender, or other protected traits."
  },
  {
    "id": 126,
    "topic_id": 200,
    "title": "Identify consumer protection risks posed by AI deception or opacity.",
    "description": "Unfair or deceptive acts — such as fake reviews, undisclosed AI interactions, misleading claims, or manipulative interfaces — can violate the FTC Act and state UDAP laws. Organizations must be transparent about how AI is used, substantiate marketing claims, and provide users with clear, accessible information."
  },
  {
    "id": 127,
    "topic_id": 200,
    "title": "Apply existing product liability principles to AI-driven physical systems.",
    "description": "When an AI system causes harm in the real world, courts may apply traditional product liability doctrines, including design defect, manufacturing defect, and failure to warn. AI’s autonomous and adaptive behavior complicates causation and responsibility, requiring rigorous testing, version tracking, and post-market monitoring."
  },
  {
    "id": 128,
    "topic_id": 200,
    "title": "Integrate legal and compliance risk management into the AI lifecycle.",
    "description": "Compliance with sectoral and civil laws cannot be an afterthought. Organizations must embed legal review, bias mitigation, documentation, and human oversight throughout the AI development pipeline, especially when systems affect rights, safety, or access to critical goods and services."
  },
  {
    "id": 129,
    "topic_id": 200,
    "title": "AI systems are classified into four risk tiers: prohibited, high-risk, limited-risk, and minimal-risk.",
    "description": "This classification scheme determines the level of regulatory control imposed. Prohibited systems are banned outright due to their potential to cause unacceptable harm. High-risk systems are subject to the most stringent obligations, while limited- and minimal-risk systems face more targeted or voluntary requirements."
  },
  {
    "id": 130,
    "topic_id": 200,
    "title": "High-risk AI systems must meet detailed compliance obligations before market placement.",
    "description": "Requirements include conformity assessments, technical documentation, risk management procedures, human oversight, post-market monitoring, and business records. The goal is to ensure safety, reliability, and accountability throughout the AI lifecycle."
  },
  {
    "id": 131,
    "topic_id": 200,
    "title": "General-purpose AI (GPAI) systems face unique requirements based on scale and systemic impact.",
    "description": "GPAI providers must document system architecture, disclose intended uses and risks, and conduct model evaluations. If the system poses systemic risk, enhanced obligations such as external audits and regulator notification apply. Requirements for GPAI systems are in addition to the requirements corresponding to the system’s risk classification (high-risk, limited-risk, and minimal-risk)."
  },
  {
    "id": 132,
    "topic_id": 200,
    "title": "The role an organization plays (provider, deployer, importer, or distributor) determines its legal responsibilities.",
    "description": "Providers carry the heaviest burden, but deployers must ensure safe implementation and oversight. Importers verify compliance for non-EU systems, and distributors must act upon credible non-compliance alerts. Clear role definitions are essential to fulfilling obligations."
  },
  {
    "id": 133,
    "topic_id": 200,
    "title": "Penalties under the EU AI Act can reach up to €35 million or 7% of global turnover.",
    "description": "The Act establishes a tiered enforcement system, with penalties calibrated to the type and severity of the violation. Prohibited practices incur the highest fines, but even documentation failures or non-cooperation can result in substantial financial penalties and mandatory corrective action."
  },
  {
    "id": 134,
    "topic_id": 200,
    "title": "The NIST AI RMF is built around four core functions: Govern, Map, Measure, and Manage.",
    "description": "These four functions form the backbone of the AI RMF and guide organizations through the full lifecycle of AI risk management, which is an essential component of AI governance. The RMF Govern function establishes accountability and oversight structures. Map involves identifying the system, its context, and relevant risks. Measure focuses on evaluating system performance and risk posture. Manage includes mitigation strategies and incident response. Understanding each function and its supporting categories is essential for applying the framework effectively."
  },
  {
    "id": 135,
    "topic_id": 200,
    "title": "ISO/IEC 22989 provides a standard AI governance lexicon.",
    "description": "This standard provides standard definitions of key terms used in AI governance and management. The standard defines terms but lacks operational guidance, which is found instead in ISO/IEC 42001."
  },
  {
    "id": 136,
    "topic_id": 200,
    "title": "ISO/IEC 42001 is the first certifiable AI management system standard.",
    "description": "This standard provides a formal structure for operationalizing AI governance within organizations. Modeled after ISO 27001, it includes clauses for leadership, planning, risk management, performance evaluation, and continual improvement. Certification under ISO/IEC 42001 allows organizations to demonstrate due diligence and alignment with emerging regulatory expectations."
  },
  {
    "id": 137,
    "topic_id": 200,
    "title": "The OECD AI Principles establish an ethical foundation for international AI governance.",
    "description": "Adopted by over 40 countries, these voluntary principles promote inclusive growth, human-centered values, transparency, robustness, and accountability. They serve as a global reference point and have directly influenced regulations such as the EU AI Act and policies from G7 member states."
  },
  {
    "id": 138,
    "topic_id": 200,
    "title": "NIST ARIA provides technical methods to assure AI system safety and trustworthiness.",
    "description": "ARIA complements the AI RMF by offering specific tools and metrics for testing AI systems, including stress testing, conformance evaluation, explainability assessments, and simulation. It supports qualitative and quantitative methods for verifying AI behavior under real-world conditions."
  },
  {
    "id": 139,
    "topic_id": 200,
    "title": "IEEE, UNESCO, the G7, and the EU HLEG have each contributed significant AI frameworks.",
    "description": "These global initiatives address various ethical, societal, and technical aspects of AI governance. For example, IEEE 7000 emphasizes ethically aligned design, UNESCO promotes human rights–centered AI, the G7 Hiroshima Process outlines AI governance, and the EU HLEG provided early guidance on trustworthy AI. While non-binding, these frameworks shape regulatory and organizational priorities worldwide."
  },
  {
    "id": 140,
    "topic_id": 200,
    "title": "Documenting the AI lifecycle ensures traceability, accountability, compliance, and audit readiness.",
    "description": "From system design to testing, comprehensive documentation provides the foundation for governance, compliance, and future maintenance. It supports explainability, allows teams to replicate decisions, and enables post-incident analysis when systems fail or behave unexpectedly."
  },
  {
    "id": 141,
    "topic_id": 200,
    "title": "Defining the business context and use case(s) aligns AI development with real-world needs and constraints.",
    "description": "AI systems must solve clearly and formally defined problems, serve specific user groups, and operate within set performance boundaries. Understanding business objectives, stakeholder roles, and the operational environment ensures that design choices are relevant and accountable."
  },
  {
    "id": 142,
    "topic_id": 200,
    "title": "Impact assessments are not optional for high-risk AI systems but are a legal and ethical necessity.",
    "description": "Impact assessments identify potential risks, harms, fairness concerns, and gaps in oversight. They are required under frameworks like the EU AI Act and Canada’s DADM and serve as a central governance tool to ensure that the AI system aligns with legal, ethical, and organizational expectations."
  },
  {
    "id": 143,
    "topic_id": 200,
    "title": "Design decisions must balance technical performance with ethical, human-centered, operational considerations.",
    "description": "Choosing a model architecture, defining metrics, and establishing thresholds often requires tradeoffs. These choices should be informed not just by accuracy but by explainability, fairness, robustness, and usability. Impactful design decisions should be made by appropriate leadership and documented. Design also includes creating effective human-in-the-loop mechanisms and feedback paths."
  },
  {
    "id": 144,
    "topic_id": 200,
    "title": "Organizations deploying proprietary models assume greater liability and governance responsibilities.",
    "description": "Unlike off-the-shelf tools, proprietary AI systems place full lifecycle accountability on the development organization. This includes legal exposure, regulatory classification as a provider, and the burden of maintaining documentation, oversight, and audit readiness internally."
  },
  {
    "id": 145,
    "topic_id": 200,
    "title": "Data governance is a foundational enabler for the development of trustworthy AI.",
    "description": "While not always a strict legal requirement, data governance ensures that the data used in AI systems is lawful, reliable, and appropriately managed. Poor or no governance can lead to biased outcomes, regulatory exposure, and a loss of stakeholder trust. Effective governance includes lawful data use, role assignment, data quality monitoring, and alignment with business purpose."
  },
  {
    "id": 146,
    "topic_id": 200,
    "title": "Data provenance and lineage must be documented to support accountability, traceability, and reproducibility.",
    "description": "Provenance explains where the data originated and under what conditions it was collected, while lineage tracks how it is transmitted and modified across systems. Both are essential for auditability and understanding model behavior, particularly when facing regulatory reviews or real-world performance issues."
  },
  {
    "id": 147,
    "topic_id": 200,
    "title": "AI testing is broader than traditional software testing and must address fairness, robustness, and interpretability.",
    "description": "AI system testing encompasses unit, integration, validation, and performance testing, and must also include ethical dimensions, such as bias, explainability, and security. Standard metrics are insufficient; testing must also account for edge cases, subgroup disparities, and evolving risks."
  },
  {
    "id": 148,
    "topic_id": 200,
    "title": "Training and testing introduce unique risks that must be proactively identified and mitigated.",
    "description": "AI systems can fail silently if risks during training and testing are ignored. These include label noise, data drift, test leakage, and the inappropriate selection of metrics. Organizations should apply structured review processes, approval gates, validation tools, and continuous monitoring to stay ahead of potential failures."
  },
  {
    "id": 149,
    "topic_id": 200,
    "title": "A risk-aware testing culture requires organizational maturity and interdisciplinary collaboration.",
    "description": "AI testing and risk management are not solely technical activities. They require buy-in from governance teams, legal counsel, domain experts, and business leaders. Formal ownership, clear review gates, and robust documentation help ensure that AI systems are effective and accountable."
  },
  {
    "id": 150,
    "topic_id": 200,
    "title": "Model readiness requires more than accuracy: it requires documentation, governance, and conformity.",
    "description": "Before deployment, AI systems must meet both technical and governance criteria, including the creation of model cards, risk assessments, and documentation of limitations and intended use. In many regulatory contexts, such as under the EU AI Act, formal conformity assessments are required for high-risk systems."
  },
  {
    "id": 151,
    "topic_id": 200,
    "title": "Deployment must align with organizational policies, legal obligations, and operational safeguards.",
    "description": "The deployment phase of an AI system is the intersection of technical execution with legal and ethical responsibilities. Organizations must employ version control, enforce environment separation, and ensure data governance policies are followed. Deployments to production should be auditable, reversible, and compliant with cross-border data regulations and consent requirements."
  },
  {
    "id": 152,
    "topic_id": 200,
    "title": "Risk management in production includes monitoring for drift, fairness degradation, and emerging threats.",
    "description": "Once deployed, an AI system is exposed to real-world data and usage patterns that can deviate from its training context. Continuous monitoring helps detect input drift, bias, hallucinations, and attacks and should be supported by alerting tools and defined incident response procedures."
  },
  {
    "id": 153,
    "topic_id": 200,
    "title": "Retraining and maintenance must be scheduled based on system volatility and risk exposure.",
    "description": "AI models are not static: they require retraining to remain effective. Retraining frequency depends on how rapidly the operating environment changes and the criticality of the model’s outputs. High-risk or high-volume systems (for example, healthcare or customer service chatbots) may require monthly retraining with human validation."
  },
  {
    "id": 154,
    "topic_id": 200,
    "title": "Monitoring is both a technical function and a governance responsibility.",
    "description": "Effective monitoring includes logging, alerting, fairness analysis, human oversight, incidents, and regulations. These outputs feed into compliance efforts, risk registers, and responsible AI programs. Monitoring also provides critical evidence for audits, transparency reporting, and ethical assurance across an AI system’s lifecycle."
  },
  {
    "id": 155,
    "topic_id": 200,
    "title": "AI risk must be assessed across the entire lifecycle, not just at deployment.",
    "description": "AI systems evolve over time through retraining, user interactions, and environmental changes. A robust risk management program must include early-stage risk identification during design and data collection, mid-stage validation and testing, and post-deployment monitoring and forecasting. This continuous view ensures risks are not missed as the system matures or is repurposed."
  },
  {
    "id": 156,
    "topic_id": 200,
    "title": "Vendor and open-source AI components may obscure or introduce hidden contractual and technical risks.",
    "description": "Organizations often integrate third-party AI tools, which may include restrictive licenses, data usage and ownership clauses, and disclaimers of liability. Exam candidates should understand the importance of identifying and vetting vendors, reviewing and revising vendor agreements, assessing transparency, and evaluating whether licensing or support terms align with the organization’s risk tolerance and regulatory obligations."
  },
  {
    "id": 157,
    "topic_id": 200,
    "title": "Auditing and testing AI models requires a blend of technical and adversarial methods.",
    "description": "Effective AI system assurance requires performance audits, red teaming, threat modeling, threat hunting, and security testing. These activities reveal vulnerabilities such as bias, prompt injection, model poisoning, data leakage, or system misuse. Candidates should be familiar with these methods and know when each is most appropriate, especially in safety-critical or regulated domains."
  },
  {
    "id": 158,
    "topic_id": 200,
    "title": "AI incident response must include documentation, cross-functional review, and a feedback loop into governance processes.",
    "description": "When an AI system causes harm or fails unexpectedly, organizations must detect the issue early, respond quickly, contain the impact, and identify the root cause. Exam-takers should be familiar with the steps of AI-specific incident management, including detection, triage, communication, investigation, containment, eradication, recovery, post-incident review, and documentation, and know how these align with compliance requirements and stakeholder expectations."
  },
  {
    "id": 159,
    "topic_id": 200,
    "title": "Public disclosure of AI risks and incidents is increasingly required by law.",
    "description": "Frameworks, such as the EU AI Act and Canada’s AIDA (as of the time of writing, AIDA has not yet been enacted), require transparency for high-risk systems, including technical documentation, usage instructions, and post-market monitoring. Candidates should understand the scope of disclosure obligations, how to tailor communications to different audiences, and the documentation artifacts that support compliance with these obligations."
  },
  {
    "id": 160,
    "topic_id": 200,
    "title": "AI incidents, issues, and risks must be documented systematically to support governance, accountability, and regulatory compliance.",
    "description": "Effective AI governance relies on maintaining accurate records of system behavior, particularly when errors, failures, or emerging risks occur. These records inform audits, help identify patterns, and demonstrate due diligence to regulators and stakeholders."
  },
  {
    "id": 161,
    "topic_id": 200,
    "title": "External communication plans must provide accurate, accessible, and timely information about AI system capabilities, limitations, and incidents.",
    "description": "Communication is a core part of building public trust and meeting legal obligations. Whether disclosing an AI model’s intended use or responding to a critical incident, organizations must be prepared with clear policies, messaging templates, designated spokespeople, and approved messaging channels."
  },
  {
    "id": 162,
    "topic_id": 200,
    "title": "AI systems should be retired through a structured, policy-driven process that minimizes disruption and preserves essential records.",
    "description": "Decommissioning an AI system involves more than turning off the model. A comprehensive retirement process includes planning, stakeholder notification, data archiving, and risk mitigation, especially in high-risk and regulated domains."
  },
  {
    "id": 163,
    "topic_id": 200,
    "title": "Localization may be necessary to comply with regional regulations, cultural norms, or data residency requirements.",
    "description": "AI systems deployed globally may need to be deactivated, modified, or retrained for use in specific jurisdictions. Localization ensures compliance with regional laws, such as the EU AI Act, and helps avoid ethical or operational problems."
  },
  {
    "id": 164,
    "topic_id": 200,
    "title": "Retirement planning should be integrated into the AI lifecycle from the start.",
    "description": "Designing systems with the end in mind enables smoother transitions, reduces last-minute risks, and aligns with principles of responsible AI. Planning ahead makes retirement a routine governance activity rather than a disruptive event."
  }
];
